import { render, staticRenderFns } from "./TreeNodeAttributes.vue?vue&type=template&id=248e0a1a&scoped=true&"
import script from "./TreeNodeAttributes.vue?vue&type=script&lang=ts&"
export * from "./TreeNodeAttributes.vue?vue&type=script&lang=ts&"
import style0 from "./TreeNodeAttributes.vue?vue&type=style&index=0&id=248e0a1a&scoped=true&lang=scss&"
import style1 from "./TreeNodeAttributes.vue?vue&type=style&index=1&id=248e0a1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248e0a1a",
  null
  
)

export default component.exports